<!-- NOVA Date Range Filter Component -->
<div class="nova-date-range-filter-container" [class.nova-open-upward]="openUpward">
  <nova-daterange-picker
    [openUpward]="openUpward"
    [valueFromParent]="currentRangeFromService"
    (onDateSelect)="onDateSelect($event)">
  </nova-daterange-picker>
</div>
